import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import ui from 'stores/ui';
import withI18n from 'utils/i18n/withI18n';
import i18nType from 'utils/i18n';
import withLazyLoad from 'utils/withLazyLoad';
import withPid from 'utils/withPid';

import Banner from './Banner';
import Platform from './Platform';
import HomeContent from './HomeContent';

import './style.scss';

interface IHomeProps {
    i18n: typeof i18nType;
}

class Home extends Component<IHomeProps> {
    componentDidMount() {
        ui.setNavTheme('default');
    }

    render() {
        return (
            <div className="page-home">
                <Helmet>
                    <title>Invest in Stocks, ETF’s, Options and more with TradeUP</title>
                    <meta
                        name="description"
                        content="Reimagine Investing with TradeUP! Our FinTech platform helps you trade stocks, options and more commission-free with confidence. GET STARTED!"
                    />
                </Helmet>
                <Banner />
                <Platform />
                <HomeContent />
            </div>
        );
    }
}

export default withI18n(withLazyLoad(withPid('home')(Home)));
